export const product = [
    {
        "product_id": "p01",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p02",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p03",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p04",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p05",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p06",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p07",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p08",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p09",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p010",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p011",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
    {
        "product_id": "p012",
        "product_name": "paneer",
        "category": "dairy",
        "sub_category": "none",
        "price": 200,
        "per_kg_l": "kg"
    },
]